export default {
  data() {
    return {
      transition: 'fade',
      breadcrumbs: null,
      nav: true,
    };
  },
  methods: {
    getPathDepth(path) {
      const clean = path.replace(/^\/|\/$/g, '');
      return clean ? clean.split('/').length : 0;
    },
    setTransition(to, from, defaultTransition = 'fade') {
      const toDepth = this.getPathDepth(to.path);
      const fromDepth = this.getPathDepth(from.path);
      this.transition = defaultTransition;
      if (toDepth !== fromDepth) {
        this.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }
    },
    setBreadcrumbs() {
      if (typeof this.$route.meta.breadcrumbs !== 'undefined') {
        this.breadcrumbs = this.$route.meta.breadcrumbs(this.$route);
      }
    },
    setNav() {
      this.nav = true;
      if (typeof this.$route.meta.nav !== 'undefined') {
        this.nav = this.$route.meta.nav;
      }
    },
  },
};
